export const getIsPassedTest = (score: number, maxScore: number) => {
  return score > maxScore / 2
}
